export default __webpack_public_path__ + "static/media/logo.aca7e8ae.png";